export class LanguageConverter {
    static Map(languageCode:string): string {        
        if (languageCode) {
            if (languageCode.indexOf('da') > -1) {
                return 'da'; //Danish (da)
            }
            else if (languageCode.indexOf('de') > -1) {
                return 'de'; //German (de)
            }
            else if (languageCode.indexOf('es') > -1) {
                return 'es'; //Spanish (es)
            }
            else if (languageCode.indexOf('fi') > -1) {
                return 'fi'; //Finnish (fi)
            }
            else if (languageCode.indexOf('fr') > -1) {
                return 'fr'; //French (fr)
            }
            else if (languageCode.indexOf('it') > -1) {
                return 'it'; //Italian (it)
            }
            else if (languageCode.indexOf('ja') > -1) {
                return 'ja'; //Japanese (ja)
            }
            else if (languageCode.indexOf('ko') > -1) {
                return 'ko'; //Korean (ko)
            }
            else if (languageCode.indexOf('nb') > -1) {
                return 'nb'; //Norwegian (nb-NO)
            }
            else if (languageCode.indexOf('nl') > -1) {
                return 'nl'; //Dutch (nl)
            }
            else if (languageCode.indexOf('pt') > -1) {
                return 'pt'; //Portuguese (pt)
            }
            else if (languageCode.indexOf('ru') > -1) {
                return 'ru'; //Russian (ru)
            }
            else if (languageCode.indexOf('sv') > -1) {
                return 'sv'; //Swedish (sv)
            }
            else if (languageCode.indexOf('zh') > -1) {
                return 'zh-CN'; //Chinese (Simplified, China) (zh-CN)
            }
        }
        return 'en-US'; //English(United States)(en - US)
    }
}